/* Dopamine Warehouse — storefront behaviour (vanilla JS) */
(function () {
  'use strict';

  /* ── Toast ─────────────────────────────────────────────────── */
  function toast(message) {
    var el = document.querySelector('.dw-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'dw-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = message;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }
  window.dwToast = toast;

  /* ── Cart count badge ──────────────────────────────────────── */
  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
      node.style.display = count > 0 ? '' : 'none';
    });
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); return cart; });
  }

  /* ── Mobile nav toggle ─────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-nav]');
      if (nav) {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
  });

  /* ── AJAX add to cart (product cards + sticky buttons) ─────── */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function (item) {
        return refreshCart().then(function () {
          toast((item.product_title || 'Added') + ' — in the bag');
        });
      })
      .catch(function (err) {
        toast((err && err.description) || 'Could not add that. Honestly? Same.');
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = original; }
      });
  });

  /* ── Cart page quantity steppers ───────────────────────────── */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('[data-qty]');
    var input = wrap && wrap.querySelector('input[type="number"], [data-qty-input]');
    if (!input) return;
    var delta = parseInt(step.getAttribute('data-qty-step'), 10);
    var next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ── Lobby hero parallax (pointer-driven depth) ────────────── */
  (function () {
    var scene = document.querySelector('[data-hero-scene]');
    if (!scene) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(hover: hover)').matches) return;
    window.addEventListener('pointermove', function (e) {
      var x = e.clientX / window.innerWidth - 0.5;
      var y = e.clientY / window.innerHeight - 0.5;
      scene.style.transform = 'scale(1.08) translate(' + (x * -18).toFixed(1) + 'px,' + (y * -14).toFixed(1) + 'px)';
    });
  })();

  /* ── Scroll reveal ─────────────────────────────────────────── */
  (function () {
    var els = document.querySelectorAll('.dw-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.16 });
    els.forEach(function (el) { io.observe(el); });
  })();

  document.addEventListener('DOMContentLoaded', refreshCart);
})();
